import {defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import Cart from "../../Shared/Cart";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default defineComponent({
  template: html,
  components: { Cart },
  emits: {
    next: () => true
  },
  setup() {
    // Injections
    const { t } = useI18n();

    return {
      t,
    };
  },
} as any);
